/* eslint-disable no-console */
define((require, exports, module) => {
    const $ = require('jquery');
    const inherit = require('inherit');
    const Emitter = require('Emitter');
    require('Promise');

    const DmrFrame = inherit(Emitter, {
        constructor: function DmrFrame(settings) {
            settings || (settings = {});

            DmrFrame.parent.call(this, settings);

            this._el = settings.el;
            this._frame = null;
            this._className = settings.className || '';

            this._onMessage = this._onMessage.bind(this);
            this._loaded = false;
        },

        load(url) {
            return new Promise((resolve, reject) => {
                this._loadResolver = resolve;
                this._loadRejector = reject;

                this._frame = document.createElement('iframe');

                this._frame.className = 'dmr-frame ' + this._className;

                this._frame.src = url;

                this._frame.onload = this._onFrameLoad.bind(this);
                this._frame.onerror = this._onFrameError.bind(this);

                this._frameTimeout = setTimeout(
                    this._onFrameTimeout.bind(this),
                    DmrFrame.FRAME_FIMEOUT,
                );

                window.addEventListener('message', this._onMessage, false);

                this._el.appendChild(this._frame);

                /* this._onMessage({
                    origin: 'https://mcs.mail.ru',
                    data: '{ "action":"action", "type": "type" }'
                });*/
            });
        },

        // eslint-disable-next-line
        _onMessage(e) {
            if (
                !e.origin.match(/https:\/\/[^/]+\.(devmail|mail)\.ru(:\d+)?$/i)
            ) {
                return;
            }

            console && console.log && console.log(e);

            let event = e.data;

            try {
                event = JSON.parse(event);
            } catch (e) {
                event = {};
            }

            if (!event.type || !event.action) {
                return;
            }

            const type = event.type;
            const action = event.action;

            if (!this._loaded) {
                this._loaded = true;
                clearTimeout(this._frameTimeout);

                this.emit(DmrFrame.EVENT_LOADING);

                if (type === 'billing' && action === 'payError') {
                    this.emit(DmrFrame.EVENT_LOAD_ERROR);
                    this._loadRejector(DmrFrame.EVENT_LOAD_ERROR);
                } else {
                    this.emit(DmrFrame.EVENT_LOADED);
                    this._loadResolver(DmrFrame.EVENT_LOADED);
                }
            }

            if (type === 'payment') {
                if (action === 'refreshWindow') {
                    this.emit(DmrFrame.EVENT_RETRY);
                } else if (action === 'closeWindow') {
                    this.emit(DmrFrame.EVENT_CLOSE);
                }
            } else if (type === 'billing') {
                if (action === 'paySuccess') {
                    this.emit(DmrFrame.EVENT_PAYMENT_SUCCESS);
                } else if (action === 'payCancel') {
                    this.emit(DmrFrame.EVENT_PAYMENT_CANCEL);
                } else if (action === 'payError') {
                    this.emit(DmrFrame.EVENT_PAYMENT_FAIL);
                } else if (action === 'closeWindow') {
                    this.emit(DmrFrame.EVENT_CLOSE);
                }
            }

            this.emit(DmrFrame.EVENT_MESSAGE, {
                type: event.type,
                action: event.action,
            });
        },

        _onFrameTimeout() {
            this._loadRejector(DmrFrame.EVENT_LOAD_ERROR_TIMEOUT);

            this.emit(DmrFrame.EVENT_LOAD_ERROR_TIMEOUT);
            this.emit(DmrFrame.EVENT_LOAD_ERROR);
        },

        _onFrameLoad() {},

        _onFrameError() {
            clearTimeout(this._frameTimeout);

            this._loadRejector(DmrFrame.EVENT_LOAD_ERROR);

            this.emit(DmrFrame.EVENT_LOAD_ERROR);
        },

        _destroyFrame() {
            clearTimeout(this._frameTimeout);
            this._frame.src = 'about::blank';
            this._frame.onload = this._frame.onerror = null;
            this._frame.parentNode.removeChild(this._frame);

            this._frame = null;
            this._loadResolver = this._loadRejector = null;
            this._loaded = false;

            window.removeEventListener('message', this._onMessage, false);
        },

        destroy() {
            if (this._frame) {
                this._destroyFrame();
            }

            this.off();
        },
    });

    $.extend(DmrFrame, {
        FRAME_FIMEOUT: 60000,

        EVENT_LOADED: 'loaded',
        EVENT_LOADING: 'loading',
        EVENT_LOAD_ERROR: 'load-error',
        EVENT_LOAD_ERROR_TIMEOUT: 'load-error-timeout',
        EVENT_RETRY: 'retry',
        EVENT_PAYMENT_SUCCESS: 'payment-success',
        EVENT_PAYMENT_CANCEL: 'payment-cancel',
        EVENT_PAYMENT_WAITING: 'payment-waiting',
        EVENT_PAYMENT_FAIL: 'payment-fail',
        EVENT_CLOSE: 'close',
        EVENT_MESSAGE: 'message',
    });

    module.exports = DmrFrame;
});
